import { render, staticRenderFns } from "./leifeng-setting.vue?vue&type=template&id=142eabe8&scoped=true&"
import script from "./leifeng-setting.vue?vue&type=script&lang=js&"
export * from "./leifeng-setting.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-setting.vue?vue&type=style&index=0&id=142eabe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142eabe8",
  null
  
)

export default component.exports